
// import "./stream.css";
// import Navbar from "../navbarv2/navbar";
// import Footer from "../navbarv2/footer";
// import { Link } from "react-router-dom";
// import React, { useState, useEffect } from "react";
// import moodenglive from "../img/cardlive-moodeng.jpg";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faVideo } from "@fortawesome/free-solid-svg-icons";

// function VDOLive() {
//   const [data, setData] = React.useState([]);


//   useEffect(() => {
//     fetchData();
//   }, []);
//   const fetchData = () => {
//     const requestOptions = {
//       method: "GET",
//       redirect: "follow"
//     };

//     fetch("https://www.addpay.co.th/service-ui/service-my-zoo-admin/live.php", requestOptions)
//       .then((response) => response.json())
//       .then((result) => {
//         setData(result);
//       })
//       .catch((error) => console.error(error));
//   }
//   return (
//     <div className="App">
//       <Navbar />
//       <div className="text-center mt-5">
//         <p className="text-success fs-1">VDO Live Streaming</p>
//       </div>
//       <div className="container-md">
//         <div className="row d-flex justify-content-center">
//           {/* mapdata */}

//           <div className="row d-flex justify-content-center">
//             {data.map((item, index) => (
//               <div className="col-12 col-md-6 col-xl-4 mb-4" key={index}>
//                 <Link state={{
//                   img: item.img,
//                   url: item.url,
//                   name: item.name
//                 }} to={`/Live`} className="card-live mx-auto">
//                   <div className="image">
//                     <img src={item.logo} alt={item.name} />
//                   </div>
//                   <div className="content text-center">
//                     <p className="fs-4 mb-0">{item.name}</p>
//                     <div className="mt-3 btn shadow-sm">
//                       <FontAwesomeIcon icon={faVideo} className="text-success" />
//                     </div>
//                   </div>
//                 </Link>
//               </div>
//             ))}

//           </div>
//           {/* mapdata */}
//         </div>
//       </div>
//       <Footer />
//       {/* App */}
//     </div>
//   );
// }

// export default VDOLive;
import "./stream.css";
import Navbar from "../navbarv2/navbar";
import Footer from "../navbarv2/footer";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideo } from "@fortawesome/free-solid-svg-icons";

function VDOLive() {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    fetch("https://www.addpay.co.th/service-ui/service-my-zoo-admin/live.php")
      .then((response) => response.json())
      .then((result) => setData(result))
      .catch((error) => console.error(error));
  };

  return (
    <div className="App">
      <Navbar />

      <div className="text-center mt-5 mb-4">
        <p className="text-success fs-1 fw-bold">VDO Live Streaming</p>
        <p className="fs-5 text-muted">รับชมไลฟ์สดจากสวนสัตว์ของเราแบบเรียลไทม์</p>
      </div>

      <div className="py-1">
        <div className="row justify-content-center">
          {data.map((item, index) => (
            <div className="col-12 col-md-6 col-xl-3 mb-4" key={index}>
              <Link
                state={{ img: item.img, url: item.url, name: item.name }}
                to={`/Live`}
                className="card-live shadow-sm mx-auto"
              >
                <div className="image">
                  <img src={item.logo} alt={item.name} className="img-fluid" />
                  <div className="overlay">
                    <div className="live-btn">
                      <FontAwesomeIcon icon={faVideo} className="text-white me-2" />
                      LIVE
                    </div>
                  </div>
                </div>
                <div className="content text-center p-3">
                  <p className="fs-5 fw-semibold mb-0">{item.name}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default VDOLive;
